import React from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { SegmentProps } from "../../../types/interfaces/navigation";
import { SegmentedControl } from "@primer/react";

export default function Segment({ items }: SegmentProps) {
    const location = useLocation();
    const navigate = useNavigate();

    const isActiveRoute = (href: string) => {
        const hrefParts = href.split('?');
        const hrefPath = hrefParts[0].replace(/\/+$/, '');
        const hrefQueryParams = new URLSearchParams(hrefParts[1] || '');

        const currentPath = location.pathname.replace(/\/+$/, '');
        const currentQueryParams = new URLSearchParams(location.search);
        const currentTypeParam = currentQueryParams.get('type');

        // В некоторых segments меняется только один параметр, а не весь путь
        if (hrefQueryParams.has('type')) {
            const hrefTypeParam = hrefQueryParams.get('type');
            return currentPath === hrefPath && currentTypeParam === hrefTypeParam;
        }

        return currentPath === hrefPath;
    };

    const updatedTabs = items.map(tab => ({
        ...tab,
        isActive: isActiveRoute(tab.href)
    }));

    const handleTabClick = (href: string) => {
        navigate(href);
    };

    return (
        <SegmentedControl aria-label="Пользователи" onChange={index => {
            const tab = updatedTabs[index];
            if (tab && !tab.isDisabled && !tab.isActive) handleTabClick(tab.href);
        }}>
            {updatedTabs.map((tab, index) => (
                <SegmentedControl.Button
                    key={index}
                    selected={tab.isActive}
                    disabled={tab.isDisabled}
                    className={tab.isDisabled ? 'opacity-35 cursor-not-allowed' : 'opacity-100'}
                >
                    {tab.text}
                </SegmentedControl.Button>
            ))}
        </SegmentedControl>
    );
}
